// /purchase-orders — Purchase Order hub with two in-page tabs:
//   • Purchase PO — buying from vendors (reuses the existing Purchase Orders list)
//   • Sales PO    — selling to customers (reuses the existing Sales Quotations list)
//
// Both tab bodies are the existing pages' *content* components, so there is no
// duplicated backend and each keeps its own filters/pagination. Switching tabs
// resets the URL to just `?tab=…` so one tab's filter params (e.g. a PO status)
// never leak into the other tab's list query.

import { useSearchParams } from 'react-router-dom';
import { PageContainer, ErrorBoundary, Tabs } from '@bbpos/ui';
import { PurchaseOrderListContent } from './PurchaseOrderListPage';
import { QuotationListContent } from '@/pages/quotations/QuotationListPage';

type HubTab = 'purchase' | 'sales';

export function PurchaseOrderHubPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab: HubTab = searchParams.get('tab') === 'sales' ? 'sales' : 'purchase';

  return (
    <PageContainer title="Purchase Order" breadcrumbs={[{ label: 'Home', href: '/home' }, { label: 'Purchase Order' }]}>
      <div className="mb-6">
        <Tabs
          variant="segmented"
          items={[
            { id: 'purchase', label: 'Purchase PO' },
            { id: 'sales', label: 'Sales PO' },
          ]}
          activeId={tab}
          // Replace ALL params with just the tab so the other tab's filters
          // (page/search/status) don't carry over and confuse its list query.
          onChange={(id) => setSearchParams({ tab: id })}
        />
      </div>

      <ErrorBoundary resetKey={`po-hub-${tab}`}>
        {tab === 'purchase' ? <PurchaseOrderListContent /> : <QuotationListContent />}
      </ErrorBoundary>
    </PageContainer>
  );
}
